// extracted by mini-css-extract-plugin
export default {"menuBlock":"ZF-z","title":"_F-z","nav":"aG-z","flexCell":"bG-z","facetLink":"cG-z"};